import { Avatar, Grid, Typography } from '@mui/material';
import DefaultAvatar from 'components/default-avatar';
import dayjs from 'dayjs';
import { getImageBySize } from 'utils/helpers';

export const Author = ({
  avatar,
  firstName,
  lastName,
  createdAt,
}: {
  avatar: string;
  firstName: string;
  lastName: string;
  createdAt: Date;
}) => {
  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        position: 'absolute',
        bottom: '0px',
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0))',
      }}
    >
      <Grid sx={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '16px' }}>
        <Grid>
          {avatar ? (
            <Avatar
              alt="avatar"
              sx={{
                background: '#fff',
                width: '31px',
                height: '31px',
                borderRadius: '8px',
              }}
              src={getImageBySize(avatar, 31, 31)}
              variant="circular"
            />
          ) : (
            <DefaultAvatar
              initials={`${firstName?.[0]}${lastName?.[0]}`}
              variant="rounded"
              alt="avatar"
              sx={{ borderRadius: '8px', width: '31px', height: '31px', fontSize: '20px' }}
            />
          )}
        </Grid>
        <Grid>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: '600',
              lineHeight: '148%',
              fontSize: '11px',
              color: '#fff',
            }}
          >{`${firstName} ${lastName}`}</Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: '400',
              lineHeight: '148%',
              fontSize: '11px',
              color: '#fff',
            }}
          >
            {dayjs(createdAt).format('MM/DD/YYYY • h:mm A')}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
